export const ru = {
  // Navigation
  nav: {
    home: "Главная",
    services: "Услуги",
    about: "О нас",
    contact: "Контакт",
    implants: "Имплантаты",
    veneers: "Виниры",
    technology: "Технологии",
    emergency: "Экстренная помощь 24/7",
    legalNotice: "Юридическая информация",
    close: "Закрыть",
    bookNow: "Записаться сейчас",
    book: "Записаться сейчас"
  },

  // Common labels used across the app
  common: {
    bookNow: "Записаться",
    learnMore: "Узнать больше",
    getDirections: "Маршрут",
    phone: "Телефон",
    email: "Email",
    date: "Дата",
    time: "Время",
    close: "Закрыть"
  },

  // Header
  header: {
    logoText: "SeaDent Mallorca",
    phone: "603 31 96 48",
    whatsapp: "WhatsApp",
    languageToggle: "RU",
    reviews: {
      rating: "5.0",
      count: "470+ отзывов",
      google: "Отзывы в Google"
    }
  },

  // Hero Section
  hero: {
    title: "SeaDent Майорка: Ваша улыбка имеет значение.",
    subtitle: "Современная стоматология с эмпатией. Расслабляющая атмосфера, отличные результаты.",
    cta: "Записаться на прием",
    banner: {
      title: "Почувствуйте индивидуальный комфорт",
      subtitle: "(и узнайте, почему наши пациенты любят возвращаться)",
      buttons: {
        cosmetic: "Эстетическая стоматология",
        pediatric: "Детская стоматология",
        general: "Общая стоматология",
        whitening: "Отбеливание зубов"
      }
    }
  },

  // Booking Wizard (3-step flow)
  bookingWizard: {
    steps: {
      treatment: "Какой тип приема вам необходим?",
      insurance: "Выберите вашу страховку",
      dateTime: "Выберите предпочтительную дату и время"
    },
    treatments: {
      cleaning: "Профессиональная чистка зубов + осмотр (врач)",
      returningCleaning: "Чистка Зубов для Повторного Пациента (Регистрированный Стоматолог-Гигиенист) + Осмотр (Врач)",
      consultation: "Общая Стоматологическая Консультация (Врач)",
      cosmetic: "Эстетическая Стоматологическая Консультация (Врач)",
      secondOpinion: "Консультация Второго Мнения в Стоматологии (Врач)",
      emergency: "Срочный Стоматологический Прием (Рентген + Осмотр Врача)",
      whitening: "Профессиональное Отбеливание Зубов",
      botox: "Консультация по Ботоксу (Врач)",
      tmj: "Консультация по ВНЧС (Боль в Челюсти) (Врач)",
      pediatric: "Детская стоматология"
    },
    insurance: {
      search: "Введите вашу страховку",
      none: "У меня нет страховки"
    },
    navigation: {
      back: "Назад",
      next: "Далее",
      close: "Закрыть"
    },
    getDirections: "Маршрут",
    instantBookingBy: "Мгновенное бронирование через"
  },

  // Form structure used in Step 3 and elsewhere
  booking: {
    title: "Запись на прием",
    subtitle: "Запланируйте визит к нашей команде экспертов",
    form: {
      name: "Полное имя",
      email: "Электронная почта",
      phone: "Номер телефона",
      message: "Сообщение (необязательно)",
      submit: "Подтвердить бронирование",
      submitting: "Отправка...",
      success: "Спасибо! Ваша запись была подтверждена.",
      error: "Произошла ошибка при бронировании. Пожалуйста, попробуйте еще раз."
    }
  },

  // Contact Page content
  contact: {
    title: "Свяжитесь с нами",
    subtitle: "Мы рады ответить на ваши вопросы",
    contactInfo: "Контактная информация",
    phone: "Телефон",
    address: "Адрес",
    email: "Электронная почта",
    emergencyTitle: "Неотложная помощь",
    emergencyText: "Для экстренных случаев доступна круглосуточная служба",
    appointment: "Запись на прием",
    findUsTitle: "Где нас найти",
    directionsButton: "Показать маршрут",
    transportTitle: "Как добраться",
    publicTransport: "Общественный транспорт",
    publicTransportInfo: "Мы находимся в самом центре Пальмы, рядом с основными автобусными остановками на Jaime III.",
    byCar: "На автомобиле",
    byCarInfo: "Поблизости есть несколько общественных парковок, включая Parking Vía Roma и El Corte Inglés."
  },

  // Footer
  footer: {
    links: {
      title: "Навигация",
      home: "Главная",
      contact: "Контакт",
      book: "Записаться"
    },
    contact: {
      title: "Контактная информация",
      practice: "SeaDent Mallorca",
      address: "Avenida de Jaime III № 3",
      city: "07012 Пальма-де-Майорка",
      owner: "Inhaber: Jan D. Heiringhoff",
      phone: "603 31 96 48",
      whatsapp: "WhatsApp: 603 31 96 48",
      email: "info@seadent.es",
      hours: "Пн-Пт: 09:00 - 18:00"
    },
    legal: {
      title: "Юридическая информация",
      privacy: "Политика конфиденциальности",
      cookieSettings: "Настройки файлов cookie"
    },
    copyright: "© 2025 SeaDent Майорка. Все права защищены."
  },

  // Cookie Consent
  cookieConsent: {
    title: "Настройки файлов cookie",
    description: "Мы используем файлы cookie для улучшения вашего опыта. Используя наш сайт, вы соглашаетесь с нашей политикой использования файлов cookie.",
    acceptAll: "Принять все",
    acceptNecessary: "Только необходимые",
    settings: "Настройки",
    save: "Сохранить настройки",
    close: "Закрыть",
    privacyPolicy: "Политика конфиденциальности",
    categories: {
      necessary: {
        title: "Необходимые",
        description: "Эти файлы cookie необходимы для работы веб-сайта и не могут быть отключены."
      },
      preferences: {
        title: "Предпочтения",
        description: "Эти файлы cookie позволяют веб-сайту запоминать сделанный вами выбор."
      },
      statistics: {
        title: "Статистика",
        description: "Эти файлы cookie помогают нам понять, как посетители взаимодействуют с веб-сайтом."
      },
      marketing: {
        title: "Маркетинг",
        description: "Эти файлы cookie используются для предоставления посетителям релевантной рекламы и маркетинговых кампаний."
      }
    }
  },

  // Emergency Page
  emergency: {
    title: "Круглосуточная экстренная стоматологическая помощь 24/7",
    subtitle: "Мы здесь, чтобы помочь вам 24 часа в сутки",
    intro: "Если вам требуется экстренная стоматологическая помощь, немедленно свяжитесь с нами. Наша команда специалистов по неотложной помощи работает круглосуточно, чтобы обеспечить вам необходимый уход.",
    call: "Позвонить сейчас",
    whatsapp: "WhatsApp",
    cta: "Звоните: 603 31 96 48",
    details: [
      {
        title: "Доступность",
        description: "Наша команда экстренной помощи работает 24 часа в сутки, 365 дней в году, включая выходные и праздничные дни."
      },
      {
        title: "Контакт",
        description: "Свяжитесь с нами по телефону 603 31 96 48 для получения немедленной помощи. Мы также принимаем сообщения через WhatsApp."
      },
      {
        title: "Типичные экстренные случаи",
        description: "Мы лечим сильную зубную боль, переломы зубов, вывихи зубов и другие стоматологические травмы."
      },
      {
        title: "Сервис",
        description: "Мы обеспечиваем немедленное облегчение боли и долгосрочные решения, используя новейшие стоматологические технологии."
      }
    ],
    common: {
      title: "Типичные экстренные случаи",
      toothache: "Сильная зубная боль",
      broken: "Сломанный или отколотый зуб",
      knocked: "Выбитый зуб",
      bleeding: "Кровоточивость десен",
      swelling: "Отек лица",
      lost: "Выпавшая пломба или коронка"
    }
  },

  // Treatments Section
  treatments: {
    title: "Процедуры: Ваша улыбка в лучших руках",
    intro: "Наши процедуры в SeaDent Mallorca охватывают весь спектр современной стоматологии — от профилактики до эстетического совершенства. Благодаря передовым технологиям и чуткому уходу мы обеспечиваем здоровье вашей ротовой полости и сияющую улыбку.",
    cta: "Записаться на прием",
    categories: [
      {
        title: "Профилактика и гигиена",
        description: "Регулярные осмотры и профилактические меры для здоровья полости рта в долгосрочной перспективе. Мы делаем ставку на индивидуальные консультации и современную диагностику.",
        treatments: [
          {
            title: "Осмотр и консультация",
            description: "Подробное обследование и персональные рекомендации для здоровья ваших зубов."
          },
          {
            title: "Профессиональная чистка зубов",
            description: "Тщательное удаление зубного налета для ощущения чистоты и свежести."
          },
          {
            title: "Пломбы",
            description: "Высококачественные пломбы, которые восстанавливают эстетику и функциональность ваших зубов."
          },
          {
            title: "Детская профилактика",
            description: "Профилактика, адаптированная для детей, чтобы защитить зубы ваших малышей в игровой форме."
          }
        ]
      },
      {
        title: "Терапия боли",
        description: "Безболезненное лечение с использованием щадящих техник и новейших технологий. Ваше благополучие находится в центре каждого сеанса.",
        treatments: [
          {
            title: "Лечение боли",
            description: "Быстрое и эффективное облегчение зубной боли, подобранное индивидуально для вас."
          },
          {
            title: "Удаление зуба",
            description: "Бережное удаление зубов, когда другое решение невозможно."
          },
          {
            title: "Лечение корневых каналов",
            description: "Точная эндодонтия для спасения воспаленных зубов и облегчения боли."
          },
          {
            title: "Проблемы с челюстью",
            description: "Целевая терапия проблем височно-нижнечелюстного сустава (ВНЧС) для улучшения качества жизни."
          }
        ]
      },
      {
        title: "Пародонтит",
        description: "Профессиональное лечение заболеваний десен для стабильного здоровья полости рта. Своевременные меры предотвращают долгосрочный ущерб.",
        treatments: [
          {
            title: "Методы лечения",
            description: "Профессиональная чистка и терапия для эффективной борьбы с воспалением десен."
          }
        ]
      },
      {
        title: "Для идеальной улыбки (Эстетика)",
        description: "Эстетические решения для уверенной улыбки в полном соответствии с вашими пожеланиями. Наши методы бережны и эффективны.",
        treatments: [
          {
            title: "Invisalign",
            description: "Прозрачные элайнеры для незаметной и комфортной коррекции зубов."
          },
          {
            title: "Отбеливание зубов",
            description: "Бережное отбеливание зубов для белоснежной и сияющей улыбки."
          },
          {
            title: "Каппы от бруксизма",
            description: "Индивидуальные каппы для предотвращения скрежета зубами и защиты вашего прикуса."
          },
          {
            title: "Виниры",
            description: "Ультратонкие керамические накладки для идеального и естественного вида ваших зубов."
          },
          {
            title: "Коронки и мосты",
            description: "Высококачественное протезирование для восстановления функции и эстетики поврежденных зубов."
          }
        ]
      },
      {
        title: "Имплантация",
        description: "Самые современные технологии имплантации для естественного и долговечного протезирования. Наши имплантаты обеспечивают вам комфорт и безопасность.",
        treatments: [
          {
            title: "Одиночные имплантаты",
            description: "Замена отдельных зубов высококачественными имплантатами для естественного ощущения."
          },
          {
            title: "Множественная имплантация",
            description: "Комплексные решения по имплантации при больших промежутках между зубами или полном отсутствии зубов."
          },
          {
            title: "Имплантация с немедленной нагрузкой",
            description: "Имплантаты с немедленной нагрузкой для быстрого восстановления жевательной функции."
          }
        ]
      }
    ]
  },

  // Benefits Section
  benefits: {
    title: "Ваши преимущества: Превосходство, комфорт и сияющая улыбка.",
    items: [
      {
        title: "Опыт и компетентность",
        description: "Квалифицированные стоматологи, постоянно повышающие свою квалификацию."
      },
      {
        title: "Современные технологии",
        description: "Точное лечение с помощью цифрового рентгена и инновационного оборудования."
      },
      {
        title: "Ориентированный на пациента подход",
        description: "Чуткое отношение, какое вы ожидаете от друга."
      },
      {
        title: "Средиземноморская атмосфера",
        description: "Расслабляющая обстановка, вдохновленная красотой Майорки."
      },
      {
        title: "Многоязычный сервис",
        description: "Лечение на немецком, английском, испанском и русском языках."
      },
      {
        title: "Центральное расположение",
        description: "Легкий доступ в самом центре Пальма-де-Майорка."
      }
    ]
  },

  // Approach Section
  approach: {
    title: "Новый взгляд на стоматологию: Ваше благополучие — наше обещание.",
    text: "В SeaDent мы хотим, чтобы ваш визит к стоматологу стал особенным. Наша миссия — предложить вам не только превосходное медицинское лечение, но и атмосферу, в которой вы будете чувствовать себя расслабленно и услышанно. Для нас это означает:",
    points: [
      "Мы слушаем: ваши желания и потребности находятся в центре нашего внимания. Мы уделяем время индивидуальной консультации.",
      "Расслабление и безболезненное лечение: благодаря новейшим методам и вниманию к вашему самочувствию мы делаем процедуры максимально комфортными.",
      "Прозрачность создает доверие: мы четко и понятно объясняем каждый этап лечения, чтобы вы чувствовали себя в безопасности."
    ]
  },

  // Experience Section
  experience: {
    title: "Ваши моменты благополучия в SeaDent Майорка.",
    text: "В SeaDent речь идет о большем, чем просто стоматология — мы хотим, чтобы ваш визит превратился в момент релаксации. Наша клиника сочетает новейшие методы лечения с атмосферой, вдохновленной спокойствием и красотой Майорки.",
    points: [
      "Уютная атмосфера со средиземноморскими цветами и естественным светом.",
      "Дружелюбная и чуткая команда, которая тепло приветствует вас.",
      "Короткое время ожидания благодаря эффективной организации работы клиники.",
      "Комфортные зоны ожидания с Wi-Fi, напитками и растениями.",
      "Успокаивающие детали, такие как расслабляющая музыка во время лечения."
    ]
  },

  // Social Proof Section
  socialProof: {
    title: "Что говорят наши пациенты",
    reviews: [
      {
        text: "Профессионально на высшем уровне, по-человечески замечательно, здесь действительно чувствуешь себя в надежных руках ❤️. Огромное спасибо стоматологу и всей команде. Именно так я представляю себе современную, радушную клинику 🦷🤗.",
        author: "Марсель"
      },
      {
        text: "Я еще никогда не встречала такого преданного своему делу, душевного и честного стоматолога. Он всегда уделяет много времени — даже в нерабочее время — и всегда готов помочь своим пациентам. Лечение проходит профессионально и с большим сочувствием. Даже после приема он заботится о последующем уходе и хочет знать, как дела — это далеко не само собой разумеющееся. Абсолютно замечательный стоматолог, которому можно полностью доверять. Искренняя рекомендация!",
        author: "Стефани"
      },
      {
        text: "Лучший стоматолог!!! Конечно же, именно в отпуске у меня разболелся зуб после пломбы, которую поставили пару недель назад. Ждать, пока я вернусь домой в Германию к своему стоматологу, было невозможно. Я сразу получила запись к Яну Д. Хайрингхоффу. Он очень приятный человек, выслушивает, задает вопросы и прекрасно провел необходимое лечение корневого канала. Мой стоматолог в Германии позже сказала, что он проделал отличную работу. Во время и после лечения у меня не было никаких проблем или даже болей. Могу смело его рекомендовать!",
        author: "Хендрик"
      },
      {
        text: "Я была очень рада получить быстрый и простой ответ после бессонной ночи из-за острой зубной боли. Лечение также последовало незамедлительно и профессионально. Приятно, что еще есть врачи, которые работают и по субботам, и при этом остаются очень дружелюбными и компетентными. Большое спасибо.",
        author: "Т."
      },
      {
        text: "Немедленное (!) и профессиональное экстренное лечение. Прозрачно и на равных. Большое спасибо команде, я чувствовала себя в надежных руках. ДОПОЛНЕНИЕ (спустя несколько месяцев): Вернулась в клинику и на этот раз воспользовалась услугой отбеливания. Все профессионально и дружелюбно. Просто рекомендуемая клиника! 👍",
        author: "Хуберт"
      },
      {
        text: "Меня встретили и пролечили очень дружелюбно. Доктор Хайрингхофф уделил много времени и все подробно объяснил. По моей просьбе он сделал 2 рентгеновских снимка моей новой коронки. Я боялась, что у меня воспаление корня. Это было не так, и я смогла уйти со спокойной душой. Безусловно рекомендую доктора Хайрингхоффа. Спасибо за скорую помощь в воскресенье ☺️.",
        author: "Эльке"
      },
      {
        text: "Честно говоря, мои зубы раньше выглядели просто ужасно — так что на фотографиях я предпочитал серьезный вид улыбке. Но тут появился Ян! Этот парень превратил мой рот в улыбку, на которую любо-дорого посмотреть. Все очень спокойно, никакого страха перед стоматологом и внимание к деталям. Теперь я снова улыбаюсь, как в рекламе зубной пасты. Спасибо, Ян — ты мой зубной герой!",
        author: "Патрик"
      },
      {
        text: "Большое спасибо за скорую помощь. В отпуске случилась экстренная ситуация с зубом. Сразу получил запись, где меня отлично проконсультировали и пролечили. Рекомендую от всего сердца.",
        author: "Симоне"
      }
    ]
  },

  // CTA Section
  cta: {
    title: "Почувствуйте стоматологию, где вы на первом месте.",
    text: "Готовы к стоматологической практике, сочетающей профессионализм с средиземноморским комфортом? Запишитесь на прием в SeaDent Mallorca и откройте для себя новый вид стоматологии – мы будем рады приветствовать вас в Пальме!",
    bookButton: "Записаться на прием онлайн",
    callButton: "Позвоните нам",
    visitInfo: "Посетите нас: Avenida de Jaime III № 3, Palma, Mallorca."
  },

  // Services (Home page cards)
  services: {
    title: "Наши услуги",
    subtitle: "Комплексная стоматология",
    implants: {
      title: "Зубные имплантаты",
      description: "Долговечное решение при потере зубов с использованием титановых имплантатов"
    },
    veneers: {
      title: "Виниры",
      description: "Преобразите свою улыбку с помощью индивидуальных фарфоровых виниров"
    },
    cleaning: {
      title: "Профессиональная чистка",
      description: "Тщательная чистка и профилактика для оптимального здоровья полости рта"
    },
    crown: {
      title: "Коронки и мосты",
      description: "Восстановление поврежденных зубов высококачественными коронками и мостами"
    },
    orthodontics: {
      title: "Ортодонтия",
      description: "Выровняйте зубы с помощью современных ортодонтических методов"
    },
    surgery: {
      title: "Челюстно-лицевая хирургия",
      description: "Экспертные хирургические вмешательства в наших современных операционных"
    }
  },

  // Technologies Section
  technologies: {
    title: "Современные технологии",
    subtitle: "Оборудование последнего поколения",
    intro: "В SeaDent мы ставим в приоритет индивидуальную, приятную и безболезненную стоматологию благодаря использованию передовых технологий.",
    sections: [
      {
        title: "Цифровая стоматология",
        description: "Цифровые оттиски и 3D-визуализация для точной диагностики и планирования лечения.",
        benefits: [
          "Быстрая и удобная цифровая фиксация зубов.",
          "Значительно более высокий комфорт по сравнению со слепками.",
          "Возможность визуализировать результаты лечения.",
          "Способствует более быстрому и приятному лечению."
        ]
      },
      {
        title: "Дентальный лазер: Исцеляющий свет",
        description: "Дентальный лазер — это универсальный инструмент, который заменяет многие традиционные инструменты и способствует заживлению. Он работает точно, эффективно и безопасно. Преимущества лазера для вас:",
        benefits: [
          "Поддерживает заживление десен, костей и многого другого.",
          "Позволяет проводить небольшие хирургические вмешательства.",
          "Помогает в стерилизации корневых каналов.",
          "Используется для остановки кровотечения во время процедур.",
          "Эффективное лечение афт и герпеса.",
          "Поддерживает лечение пародонтита.",
          "Помогает в десенсибилизации чувствительных шеек зубов."
        ]
      },
      {
        title: "Технологии имплантации",
        description: "Передовые системы имплантации для оптимальной интеграции и долгосрочного успеха.",
        benefits: [
          "Высококачественные биосовместимые материалы",
          "Компьютерное планирование для максимальной безопасности",
          "Долговечные и естественно выглядящие результаты"
        ]
      },
      {
        title: "Стоматологический микроскоп",
        description: "Микроскопическая точность для эндодонтического лечения и тонких хирургических процедур.",
        benefits: [
          "Максимальная точность в деталях",
          "Более высокие показатели успеха при лечении корневых каналов",
          "Сохранение как можно большего количества естественной структуры зуба"
        ]
      }
    ],
    conclusion: "Сочетая эти современные технологии с нашим вниманием к доверию и прозрачности, вы испытаете в SeaDent профессиональную, приятную и персональную стоматологию."
  },


  // Other sections
  implants: {
    title: "Имплантаты – Для лучшего качества жизни",
    intro: "Зубные имплантаты — это самый современный и естественный способ замены отсутствующих зубов. Они обеспечивают не только идеальную эстетику, но и возвращают вам ощущение и уверенность в собственных зубах. В нашей клинике в Пальме мы придерживаемся самых высоких стандартов качества и используем самые современные методы.",
    benefitsTitle: "Преимущества имплантатов",
    benefit1: "Естественный вид и ощущения, сравнимые с собственными зубами",
    benefit2: "Улучшение жевательной функции и способности говорить",
    benefit3: "Долговечное решение с высоким процентом успеха",
    benefit4: "Сохранение структуры костной ткани челюсти",
    qualityTitle: "Высочайшее качество и точность",
    quality: "Мы используем только высококачественные материалы и самые современные методы цифрового планирования. Это гарантирует вам точный и долговечный результат, который идеально вам подходит.",
    experienceTitle: "Приятный опыт лечения",
    experience: "Благодаря малоинвазивным техникам и мягкой анестезии лечение у нас проходит особенно бережно. Наша цель — чтобы вы чувствовали себя комфортно и в безопасности на протяжении всего процесса.",
    processTitle: "Путь к вашим новым имплантатам",
    step1Title: "Консультация",
    step1: "Подробная беседа и индивидуальное планирование",
    step2Title: "Имплантация",
    step2: "Бережная процедура под местной анестезией",
    step3Title: "Заживление",
    step3: "Интеграция имплантата с костью челюсти",
    step4Title: "Зубной протез",
    step4: "Изготовление и установка индивидуального зубного протеза"
  },
  veneers: {
    title: "Виниры – Для вашей сияющей улыбки",
    intro: "Ультратонкие керамические накладки, известные как виниры, предлагают элегантное решение для постоянной коррекции незначительных эстетических несовершенств передних зубов. Будь то изменение цвета, небольшие промежутки или легкая кривизна — мы поможем вам достичь гармоничной и естественной улыбки.",
    imageAlt: "Лечение винирами в SeaDent Mallorca",
    description: "Виниры — это индивидуально изготовленные накладки, которые надежно прикрепляются к поверхности зуба. Они характеризуются высокой биосовместимостью и эстетикой, которую трудно отличить от натуральных зубов. Всего за несколько сеансов мы преобразим вашу улыбку и подарим вам новую уверенность в себе."
  },
  legalNotice: {
    title: "Юридическая информация",
    german: {},
    english: {},
    spanish: {}
  }
};